import React, { useState } from "react";
import {
    Grid, Box
} from "@material-ui/core";

import C1InputField from "app/c1component/C1InputField";
import { useStyles } from "app/c1utils/styles";
import C1DateField from "app/c1component/C1DateField";
import useAuth from "app/hooks/useAuth";
import C1HeaderTitle from "app/c1component/C1HeaderTitle";
import C1Container from "app/c1component/C1Container"
import { isRaeoOperator } from "app/sctcomponent/SctUtilities";

const RaeoAppReviewAcceptance = ({
    inputData,
    handleInputChange,
    handleInputChangeDeep,
    auditList,
    viewType,
    isDisabled,
    errors,
    isSubmitting }) => {

    const classes = useStyles();
    const { user } = useAuth();

    const [refreshPage, setRefreshPage] = useState(0);

    const handleInputChangeDeepWrap = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        handleInputChangeDeep(name, value);
        setRefreshPage(refreshPage + 1);
    }

    console.log("RaeoAppReviewAcceptance user:", user);

    if ((!inputData.TSctRaeoAppReviewAcceptance?.officerEmail || inputData.TSctRaeoAppReviewAcceptance?.officerEmail.trim() === "") && user.authorities.some(authority => authority.authority === 'RAEO_REVIEW_OFFICER')) {
        inputData.TSctRaeoAppReviewAcceptance.officerEmail = user.coreAccn.accnContact?.contactEmail;
    }

    

    const defaultUserName = (!isDisabled) ? user.name : "";

    return (
        <React.Fragment>
            <C1HeaderTitle>Header Information</C1HeaderTitle>

            <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                <Grid item lg={6} md={6} xs={12} >
                    <C1DateField
                        label="Reviewed Date"
                        name="aeoReviewedDate"
                        value={inputData.TSctRaeoAppReviewAcceptance?.raDtLupd || ""}
                        required
                        disabled
                    />
                </Grid>
                <Grid item lg={6} md={6} xs={12} >
                    <C1InputField
                        label="Reviewed By"
                        name="usrName"
                        value={inputData?.TSctRaeoAppReviewAcceptance?.TCoreUsr?.usrName || defaultUserName}
                        required
                        disabled
                    />
                </Grid>
            </Grid>

            <C1Container rendered={true}>

                <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                    <Grid item lg={12} md={12} xs={24} >
                        <C1InputField
                            label="Comments"
                            name="TSctRaeoAppReviewAcceptance.raReason"
                            value={inputData?.TSctRaeoAppReviewAcceptance?.raReason || ""}
                            multiline
                            rows={10}
                            required
                            disabled={isDisabled}
                            onChange={handleInputChangeDeepWrap}
                            inputProps={{ 'maxLength': 1024 }}
                            error={errors['TSctRaeoAppReviewAcceptance.raReason'] !== undefined}
                            helperText={errors['TSctRaeoAppReviewAcceptance.raReason'] || ''}
                        />
                    </Grid>

                </Grid>
            </C1Container>

            <Box width={1}>&nbsp;</Box>

        </React.Fragment>
    );
};

export default RaeoAppReviewAcceptance;